module.exports = __webpack_public_path__ + "d8be9a284740e987ffd8380eb2007e9a.jpg";